export const ROW_ID_SEPARATOR = '|';
export const FETCH_RECIPIENT_SIZE = 1000;
export const MessageRequestEditableSelector = 'MessageRequestEditable';

export const MessageRequestTypeSelector = 'MessageRequestType';
export const MessageRequestSubjectSelector = 'MessageRequestSubject';
export const MessageRequestBodySelector = 'MessageRequestBody';
export const MessageRequestKeyCodeSelector = 'MessageRequestKeyCode';
export const MessageRequestMessagingTemplateKeyCodeSelector = 'MessageRequestMessagingTemplateKeyCode';
export const MessageRequestImportanceLevelSelector = 'MessageRequestImportanceLevel';
export const MessageRequestCustomerSelector = 'MessageRequestCustomer';
export const AmsRecipientUserIdSelector = 'AmsRecipientUserId';
export const AmsRecipientSubjectIdSelector = 'AmsRecipientSubjectId';
export const AmsRecipientUserRelationTypeSelector = 'AmsRecipientUserRelationType';
export const AmsRecipientUserRelationTypeTxtSelector = 'AmsRecipientUserRelationTypeTxt';
export const AmsRecipientNameSelector = 'AmsRecipientName';
export const AmsRecipientEmailSelector = 'AmsRecipientEmail';
export const AmsRecipientTenantIdSelector = 'AmsRecipientTenantId';
export const MessageRequestChannelEmailSelector = 'messageRequestChannelEmailSelector';
export const MessageRequestChannelPushSelector = 'messageRequestChannelPushSelector';
export const MessageRequestChannelPullSelector = 'messageRequestChannelPullSelector';
export const MessageRequestPushNotificationBodySelector = 'messageRequestPushNotificationBodySelector';
export const MessageRequestDistributionChannelsSelector = 'messageRequestDistributionChannelsSelector';
